// Angular modules
import { Component }          from '@angular/core';

// Ionic modules
import { GoogleAnalytics }    from '@ionic-native/google-analytics';
import { NavController }      from 'ionic-angular';
import { MenuController }     from 'ionic-angular';
import { LoadingController }  from 'ionic-angular';
import { ToastController }    from 'ionic-angular';

// External modules
import { KeyPoint }           from '../../shared/models/keypoint';
import { Translation }        from '../../shared/models/translation';
import { ApplicationService } from '../../shared/providers/application-service';
import { KeyPointDetailPage } from '../key-point-detail/key-point-detail';
import { TranslateService }   from '@ngx-translate/core';
import _                      from 'lodash';

// Helpers
import { StorageHelper }      from '../../shared/helpers/storage.helper';
import { SynchronizePage } from '../synchronize/synchronize';


@Component({
  selector:    'page-key-points',
  templateUrl: 'key-points.html',
  providers:   [ApplicationService]
})

export class KeyPointsPage
{
  keyPoints        : KeyPoint[]    = [];
  selectedKeyPoint : KeyPoint      = null;
  overlayIndex     : number        = 0;
  translations     : Translation[] = [];
  user             : any           = null;
  waitingLabel     : string        = "Please wait...";
  overlayArray     : string []     = ['assets/menu_overlay_4.png',
                                      'assets/menu_overlay_5.png',
                                      'assets/menu_overlay_6.png',
                                      'assets/menu_overlay_7.png',
                                      'assets/menu_overlay_8.png',
                                      'assets/menu_overlay_9.png'];

  constructor(public navCtrl            : NavController,
              public loadingCtrl        : LoadingController,
              public toastCtrl          : ToastController,
              public applicationService : ApplicationService,
              public translateService   : TranslateService,
              public menuCtrl           : MenuController,
              private analytics  : GoogleAnalytics)
  {
    var context = this;

    this.initTranslations();


    if(StorageHelper.getKeyPoints() === null)
    {
      this.presentToast('You need to synchronize your data before accessing this feature');
      this.navCtrl.push(SynchronizePage);
      return;
    }

    context.user = StorageHelper.getUser();

    context.getSelectedLang();
    context.loadData();
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Key points");
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  initTranslations()
  {
    var context = this;
    this.translateService.get('PLEASE_WAIT').subscribe(
      value => {
        context.waitingLabel = value;
      })
  }

  presentLoading()
  {
     let loader = this.loadingCtrl.create({
       content: "Please wait..."
     });

     return loader;
  }

  translate(value)
  {
    var context = this;

    if(value == null)
      return value;

    if(this.translations == null || this.translations.length == 0)
      return value;

    var translate = this.translations.filter(x => context.normalizeKey(x.Name) === context.normalizeKey(value));

    if(translate == null || translate == undefined || translate.length == 0)
      return value;

    return translate[0].Value;
  }

  async getSelectedLang()
  {
    this.translations = await this.applicationService.getSelectedTranslations();
  }

  presentToast(message)
  {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  loadData()
  {
    var context = this;
    let loader  = this.presentLoading();

    loader.present();
    const keyPoints = StorageHelper.getKeyPoints();

    if(keyPoints != null)
      context.keyPoints = keyPoints;
    else
      this.presentToast("Missing Key Points, please synchronize before.");

    loader.dismiss();
  }

  selectKeypoint(item)
  {
    this.selectedKeyPoint = item;
    var selItem           = _.cloneDeep(item);
    var origItemName      = item.Name;

    selItem.Name    = this.translate(item.Name);
    selItem.Content = this.translate(item.Content);
    this.navCtrl.push(KeyPointDetailPage,
    {
      origItemName,
      selItem
    }, {animate: true});
  }

  getOverlay()
  {
    if(this.overlayIndex == 5)
      this.overlayIndex = 0;

    this.overlayIndex++;

    return this.overlayArray[this.overlayIndex];
  }

  backAction()
  {
    this.navCtrl.pop({animate: false});
  }

  normalizeKey(key)
  {
    var normKey = key.replace(/[\t\v\f\r \u00a0\u2000-\u200b\u2028-\u2029\u3000]+/g,'').trim();
    normKey     = normKey.replace(/<\/?[^>]+(>|$)/g, "");

    return normKey.toLowerCase();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/key-points/key-points.ts